import * as DomBuilder from "./dom-builder.js";
import * as Utils from "./utils.js";
import Transaction from "../Transaction.js";

/**
 * @version 2026-09-02
 * @author Patrik Harag
 */
export default class DialogDetails {

    /** @type {Controller} */
    #controller;
    /** @type {Transaction[]} */
    #transactions;
    /** @type {string} */
    #groupName;
    /** @type {Filter} */
    #filter;
    /** @type {Map<string,Filter>} */
    #filters;

    /**
     *
     * @param controller {Controller}
     * @param groupName {string}
     * @param transactions {Transaction[]}
     * @param activeFilter {Filter}
     * @param filters {Map<string,Filter>}
     */
    constructor(controller, groupName, transactions, activeFilter, filters) {
        this.#controller = controller;
        this.#groupName = groupName;
        this.#transactions = transactions;
        this.#filter = activeFilter;
        this.#filters = filters;
    }

    show() {
        let dialog = DomBuilder.bootstrapDialogBuilder();
        dialog.setHeaderContent(this.#groupName);
        dialog.setBodyContent(this.#buildBody());
        dialog.addCloseButton('Close');
        dialog.setSizeLarge();
        dialog.show(this.#controller.getDialogAnchor());
    }

    #buildBody() {
        let tableBody = DomBuilder.element('tbody');
        let table = DomBuilder.div({ class: 'table-responsive' }, [
            DomBuilder.element('table', { class: 'table table-striped' }, tableBody)
        ]);

        this.#transactions.sort(Transaction.comparator).forEach(transaction => {
            let descriptionCell = DomBuilder.element('td', null, DomBuilder.span(transaction.getDescription()));
            let valueAttrs = { class: `value-cell ${transaction.getValue() < 0 ? 'negative' : 'positive'}` };
            let tooltip = Utils.formatFxTooltip(transaction);
            let valueContent = Utils.formatValue(transaction.getValue());
            if (tooltip) {
                valueContent = DomBuilder.span(valueContent, { class: 'value-with-fx', title: tooltip });
            }
            let row = DomBuilder.element('tr', null, [
                DomBuilder.element('td', null, DomBuilder.span(transaction.getDate(), { style: 'white-space: nowrap;' })),
                descriptionCell,
                DomBuilder.element('td', valueAttrs, valueContent)
            ]);
            tableBody.append(row);

            // #filter labels
            for (const f of this.#filters.values()) {
                if (f.isHiddenInTable()) {
                    continue;
                }
                if (f.isSynthetic()) {
                    // skip synthetic #filters
                    continue;
                }
                if (this.#filter === f) {
                    // same as selected #filter
                    continue;
                }
                if (f.hasFilterFunc() && f.matches(transaction)) {
                    descriptionCell.prepend(DomBuilder.span(' '));
                    descriptionCell.prepend(Utils.createFilterLabel(f));
                }
            }
        })

        return table;
    }

}
